import React from 'react';
import { Link } from 'react-router-dom';
import { LoginHeader } from '../Common/LoginHeader';
import { Footer, Header } from '../Common';
import { connect } from 'react-redux';
import { affiliatorLogin } from '../../Action/login';
import { withRouter } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import { GoogleLoginItem } from './GoogleLoginItem';
import { FacebookLoginItem } from './FacebookLoginItem';
class AffiliatorLogin extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            _id: false,
            affEmail: '',
            affPassword: '',
            errors: [],
            message: '',
        };
        SimpleReactValidator.addLocale('klingon', {
            integer: '数字を入れてください.',
            max: ':attribute :max 文字以下にしてください .',
            required: ' :attribute を必須です.',
            min: ':attribute :min 文字以上にしてください .',
        });
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            locale: 'klingon',
        })
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        this.setState({ message: JSON.parse(window.localStorage.getItem('success') )})
        window.localStorage.removeItem('info');
        window.localStorage.removeItem('pro_pic');
        localStorage.clear();
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            this.setState({ errors: nextProps.errors })
        }
    }
    updateField(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    handleSubmit(e) {
        e.preventDefault();
        if (this.validator.allValid()) {
            let data = {}
            data = {
                email: this.state.affEmail,
                password: this.state.affPassword,

            }
            this.props.affiliatorLogin(data, this.props.history);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    successMessage() {
        console.log(this.state.message)
        if (this.state.message === 200) {
            return (
                <span className="mb-2" style={{ color: "green" }}>
                    アフィリエイト登録ありがとうございます。<br />
                    下記よりログインして下さい！
                </span>
            )
        } else {
            return (
                <span className="mb-2" style={{ color: "green" }}>
                   
                </span>
            )
        }

    }


    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        const { errors } = this.state.errors;
        if (isMobile) {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="col-md-12" >
                            <div className="">
                                <LoginHeader />
                            </div>
                        </div>
                        <div className="col-md-12 tr_blank_medium mt-5 pt-2"> </div>
                        <div className="row">
                            <div className="col-md-4"></div>
                            <div className="col-md-4 ">
                                {this.successMessage()}
                                <div className="big_text" style={{ paddingBottom: '0px' }}><b>アフィリエイターログイン</b></div>
                                <div className="login_inputs form-group " style={{ padding: '20px' }}>
                                    <form onSubmit={this.handleSubmit.bind(this)}>
                                        <span className="mb-2" style={{ color: "red" }} >{errors}</span>
                                        <div>
                                            <div className="name_text"><b>メールアドレス</b>
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <input type="email" className="user_id_box form-control" placeholder="メールIDを入力してください" id="email" value={this.state.affEmail} onChange={this.updateField.bind(this, "affEmail")} />
                                                {this.validator.message('メールアドレス', this.state.affEmail, 'required')}
                                            </div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div>
                                            <div className="name_text"><b>パスワード</b>
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <input type="password" className="user_id_box form-control" placeholder="パスワードを入力してください" id="password1" value={this.state.affPassword} onChange={this.updateField.bind(this, "affPassword")} />
                                                {this.validator.message('パスワード', this.state.affPassword, 'required')}
                                            </div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div>
                                            <div className="remember_text"><input type="checkbox" />&nbsp;&nbsp;メールアドレスを記憶する</div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div>
                                            <div className="input_name">
                                                <button type="submit" className="btn btn-lg button_size" style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >ログイン</button>
                                            </div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div><div className="input_name remember_text">パスワードお忘れた方は<Link className="blue_text" to={"/password-reset"}>こちら</Link> </div></div>
                                        <br />
                                        <div><div className="input_name remember_text">購入者ログインは<Link className="blue_text" to={"/login"}>こちら</Link> </div></div>
                                        <div><div className="input_name remember_text">販売者ログインは<Link className="blue_text" to={"/login/seller"}>こちら</Link> </div></div>
                                    </form>
                                </div>
                            </div>
                            <div className="col-md-4">
                            </div>
                        </div>
                    </div>
                    <div className=" mt-5">
                        <Footer />
                    </div>
                </div>
            );
        }
        else if (isDesktop) {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12" >
                                <div className="">
                                    <LoginHeader />
                                </div>
                            </div>
                            <div className="col-md-12 tr_blank_medium mt-5 pt-2"> </div>
                            <div className="row mt-5">
                                <div className="col-md-4"></div>
                                <div className="col-md-4 mt-5">
                                    {this.successMessage()}
                                    <div className="big_text"><b>アフィリエイターログイン</b></div>
                                    <div className="login_inputs form-group pl-5">
                                        <form onSubmit={this.handleSubmit.bind(this)}>
                                            <span className="mb-2" style={{ color: "red" }} >{errors}</span>
                                            <div>
                                                <div className="name_text"><b>メールアドレス</b>
                                                </div>
                                            </div>
                                            <div>
                                                <div>
                                                    <input type="email" className="user_id_box form-control" placeholder="メールIDを入力してください" id="email" value={this.state.affEmail} onChange={this.updateField.bind(this, "affEmail")} />
                                                    {this.validator.message('メールアドレス', this.state.affEmail, 'required')}
                                                </div>
                                            </div>
                                            <div><div>&nbsp;</div></div>
                                            <div>
                                                <div className="name_text"><b>パスワード</b>
                                                </div>
                                            </div>
                                            <div>
                                                <div>
                                                    <input type="password" className="user_id_box form-control" placeholder="パスワードを入力してください" id="password1" value={this.state.affPassword} onChange={this.updateField.bind(this, "affPassword")} />
                                                    {this.validator.message('パスワード', this.state.affPassword, 'required')}
                                                </div>
                                            </div>
                                            <div><div>&nbsp;</div></div>
                                            <div>
                                                <div className="remember_text"><input type="checkbox" />&nbsp;&nbsp;メールアドレスを記憶する</div>
                                            </div>
                                            <div><div>&nbsp;</div></div>
                                            <div>
                                                <div className="input_name">
                                                    <button type="submit" className="btn btn-lg button_size" style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >ログイン</button>
                                                </div>
                                            </div>
                                            <div><div>&nbsp;</div></div>
                                            <div><div className="input_name remember_text">パスワードお忘れた方は<Link className="blue_text" to={"/password-reset"}>こちら</Link> </div></div>
                                            <br />
                                            <div><div className="input_name remember_text">購入者ログインは<Link className="blue_text" to={"/login"}>こちら</Link> </div></div>
                                            <div><div className="input_name remember_text">販売者ログインは<Link className="blue_text" to={"/login/seller"}>こちら</Link> </div></div>
                                        </form>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className=" mt-5">
                        <Footer />
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => ({
    affiliatorLogin: state.affiliatorLogin,
    errors: state.errors,
});

AffiliatorLogin = connect(mapStateToProps, { affiliatorLogin })(withRouter(AffiliatorLogin));
export { AffiliatorLogin };